jQuery(document).ready(function($) {
    $('#clients-slider-first').owlCarousel({
        items: 7,
        autoplay: true,
        slideTransition: 'linear',
        autoplayTimeout: 2500,
        smartSpeed: 2500,
        slideSpeed: 2500,
        center: false,
        dots: false,
        nav: false,
        loop: true,
        rtl: false,
        responsive: {
            0: {
                items: 3,
                
            },
            600: {
                items: 7,
               stagePadding: 20,
            },
            1000: {
                items: 12,
              stagePadding: 50,
            }
        }
    });
  });